import { Fragment } from 'react';
import { Box, Dialog, DialogContent } from '@mui/material';
import ViewEditModalHeader from 'components/modal/ViewEditModalHeader';
import { over } from 'lodash';

const HistoryModalContainer = ({ icon, type, title, children, viewType, showModal, handleClose, setScreenSize, screenSize = 'lg' }) => {
	return (
		<Fragment>
			<Dialog
				keepMounted
				fullWidth={true}
				open={showModal}
				maxWidth={screenSize}
				aria-labelledby="draggable-dialog-title"
				fullScreen={screenSize === 'full' ? true : false}
				PaperProps={{
					sx: {
						// old: overflow: 'hidden', borderRadius: '8px'
						overflow: 'hidden',
						borderRadius: '12px',
						border: '1px solid #E2E8F0',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
					},
				}}
			>
				<ViewEditModalHeader
					type={type}
					icon={icon}
					headerTitle={title}
					viewType={viewType}
					screenSize={screenSize}
					handleClose={handleClose}
					setScreenSize={setScreenSize}
				/>

				<DialogContent
					sx={{
						// old: pb: '0', pt: '8px'
						pb: 0,
						pt: 1.5,
						px: 2,
						backgroundColor: '#FFFFFF',

						'& .ant-form-item-label': {
							paddingBottom: '12px',
						},
					}}
				>
					<Box>{children}</Box>
				</DialogContent>
			</Dialog>
		</Fragment>
	);
};

export default HistoryModalContainer;
